/* global window */
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// eslint-disable-next-line import/extensions
import { useTimeOnPage } from '@3plearning/mx-teacher-analytics/react';

import {
    getAnalytics,
    trackEvent,
    trackSession,
    ANALYTICS_EVENTS
} from '../../helpers/analytics';
import {
    ACTIVITY_MASTERY_PATH,
    PARTICIPATION_PATH,
    LIVE_MATHS_PATH,
    SKILL_QUESTS_MASTERY_PATH,
    YEAR_GROUP_PATH,
    TEACHER_PATH,
    CLASS_PATH,
    GROUP_PATH,
    STUDENT_PATH
} from '../../helpers/constants';

const REPORT_PATHS = {
    [ACTIVITY_MASTERY_PATH]: 'activity-mastery',
    [PARTICIPATION_PATH]: 'participation',
    [LIVE_MATHS_PATH]: 'live-maths',
    [SKILL_QUESTS_MASTERY_PATH]: 'skill-quests-mastery'
};

const ALL_CLASSES_LEVEL = 'all-classes';

function getReportType(pathname) {
    const match = Object.keys(REPORT_PATHS).find((path) =>
        pathname.startsWith(path)
    );
    return match ? REPORT_PATHS[match] : null;
}

function getReportLevel(pathname) {
    const segments = pathname.split('/');
    if (segments.includes(STUDENT_PATH)) return 'student';
    if (segments.includes(GROUP_PATH)) return 'group';
    if (segments.includes(CLASS_PATH)) return 'class';
    if (segments.includes(TEACHER_PATH)) return 'teacher';
    if (segments.includes(YEAR_GROUP_PATH)) return 'year';
    return ALL_CLASSES_LEVEL;
}

/**
 * Headless component that drives page/report analytics from the router.
 * Fires page.view once on mount and report.view whenever the report type
 * or drill-down level changes. Emits no UI.
 */
export function AnalyticsTracker({ location }) {
    useTimeOnPage(getAnalytics());

    const mountedRef = useRef(false);
    const lastViewRef = useRef(null);

    useEffect(() => {
        if (mountedRef.current) return;
        mountedRef.current = true;
        trackEvent(ANALYTICS_EVENTS.pageView, {});
        trackSession(window.location.pathname);
    }, []);

    useEffect(() => {
        const report = getReportType(location.pathname);
        if (!report) return;

        const level = getReportLevel(location.pathname);
        const view = `${report}:${level}`;
        if (lastViewRef.current === view) return;

        lastViewRef.current = view;
        trackEvent(ANALYTICS_EVENTS.reportView, { report, level });
    }, [location.pathname]);

    return null;
}

AnalyticsTracker.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string
    }).isRequired
};

export default withRouter(AnalyticsTracker);



// WEBPACK FOOTER //
// ./components/analytics-tracker/analytics-tracker.js